import { generateWhatsAppUrl } from "../../lib/whatsapp";

export default function FloatingWhatsApp() {
  const href = generateWhatsAppUrl();
  return (
    <>
      {/* Desktop floating pill (bottom-right) */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-desktop"
        className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-2.5 pl-3 pr-5 py-3 bg-emerald text-ink rounded-full shadow-2xl shadow-emerald/25 hover:bg-emerald-light transition-colors group"
      >
        <span className="relative grid place-items-center w-8 h-8">
          <span className="absolute inset-0 rounded-full bg-white/40 animate-pulseRing" />
          <span className="relative grid place-items-center w-8 h-8 rounded-full bg-white/95">
            <WhatsIcon className="w-4 h-4 text-emerald" />
          </span>
        </span>
        <span className="text-sm font-semibold">Get a Free Quote</span>
      </a>

      {/* Mobile bottom sticky bar */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-mobile"
        className="md:hidden fixed left-3 right-3 bottom-3 z-40 inline-flex items-center justify-center gap-2 py-4 rounded-full bg-emerald text-ink text-base font-semibold shadow-2xl"
      >
        <WhatsIcon className="w-5 h-5" />
        Get a Quote via WhatsApp
      </a>
    </>
  );
}

function WhatsIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path d="M20.5 3.5A11 11 0 0 0 3.7 17.2L2 22l4.9-1.6a11 11 0 0 0 5.2 1.3h.1a11 11 0 0 0 8.3-18.2Zm-8.4 17a9 9 0 0 1-4.6-1.3l-.3-.2-2.9.9.9-2.8-.2-.3a9 9 0 1 1 7.1 3.7Zm5-6.7c-.3-.1-1.8-.9-2-1s-.5-.1-.7.2-.8 1-.9 1.1-.3.2-.6.1a7.3 7.3 0 0 1-2.2-1.4 8 8 0 0 1-1.5-1.9c-.2-.3 0-.4.1-.6l.4-.4.2-.4v-.4l-1-2.3c-.2-.6-.4-.5-.6-.5h-.6c-.2 0-.5.1-.8.4a3.6 3.6 0 0 0-1.1 2.7c0 1.6 1.1 3.1 1.3 3.3.2.3 2.3 3.4 5.5 4.8.8.3 1.4.5 1.8.6.8.3 1.5.2 2 .1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4l-.5-.3Z" />
    </svg>
  );
}
